export const ASSOCIATED_MATERIALS_NAME = 'Associated Materials'
export const BEN_MOORE_NAME = 'Ben Moore'
export const CASCADES_NAME = 'Cascades'
export const CHATHAM_STEEL_NAME = 'Chatham Steel'
export const DO_IT_BEST_NAME = 'Do It Best'
export const GOODYEAR_NAME = 'Goodyear'
export const HARLEY_DAVIDSON_NAME = 'Harley Davidson'
export const HYSTER_YALE_GROUP_NAME = 'Hyster-Yale Group'
export const INTERNATIONAL_NAME = 'International'
export const KEURIG_DR_PEPPER_NAME = 'Keurig Dr Pepper'
export const SGWS_NAME = 'Southern Glazers Wine and Spirits'
export const TRUE_VALUE_NAME = 'True Value'

export const CUSTOMER_ANALYTICS_URLS: Record<string, string> = {
  [ASSOCIATED_MATERIALS_NAME]: 'https://mixpanel.com/p/Cha2TrBGn5wDWotGsPiEQ9',
  [HARLEY_DAVIDSON_NAME]: 'https://mixpanel.com/p/Kda9RYuW7952ed8fwVX4z6',
  [BEN_MOORE_NAME]: 'https://mixpanel.com/p/WnSkgWpv7CK1SdJ5UDcugY',
  [INTERNATIONAL_NAME]: 'https://mixpanel.com/p/JfTq1kiJaPZpzCemAoqD97',
  [CHATHAM_STEEL_NAME]: 'https://mixpanel.com/p/MXkH3pfBwveKy1pH4MuZwU',
  [DO_IT_BEST_NAME]: 'https://mixpanel.com/p/QidWUPLsXUCJRKiHL6Ts3L',
  [GOODYEAR_NAME]: 'https://mixpanel.com/p/97eGwh9HRtxQryhqZEUAzi',
  [TRUE_VALUE_NAME]: 'https://mixpanel.com/p/1c8ByiDoCy3QthUjevt5Bn',
  [HYSTER_YALE_GROUP_NAME]: 'https://mixpanel.com/p/PSGCfJySw92AMuTp4gp43P',
  [KEURIG_DR_PEPPER_NAME]: 'https://mixpanel.com/p/WBhK81CBDbn3xxSCiXkL7Q',
  [CASCADES_NAME]: 'https://mixpanel.com/p/BABTzWmGr58QDZhJ7Mr442',
}
